module.exports = __webpack_public_path__ + "static/vegetace2-0c528e16bc9c984edf34a74b5bdea399.jpg";